module.exports = __webpack_public_path__ + "static/media/VectorPointConcluido5.f73d939c.svg";